uniform float uTime;
uniform float uSize;
uniform float uPixelRatio;
uniform float uFallHeight; // 降下範囲（この高さ分を落ちたら上へループ）
uniform float uFallSpeed;

attribute float aScale;
attribute float aOffset;   // 個体ごとの位相（0-1）
attribute float aColorMix; // 緑〜紫のミックス比（0-1）

varying float vOffset;
varying float vColorMix;

void main()
{
    vec3 pos = position;

    // 上から下へゆっくり降下し、範囲を抜けたら上へループ
    pos.y -= mod(aOffset * uFallHeight + uTime * uFallSpeed * (0.6 + 0.8 * aOffset), uFallHeight);

    // 落ちながら左右にゆらゆら揺れる
    pos.x += sin(uTime * 0.4 + aOffset * 6.2831) * 1.2;
    pos.z += cos(uTime * 0.3 + aOffset * 6.2831) * 0.8;

    vec4 viewPosition = viewMatrix * modelMatrix * vec4(pos, 1.0);
    gl_Position = projectionMatrix * viewPosition;

    // 遠近でサイズを変える
    gl_PointSize = uSize * aScale * uPixelRatio * (1.0 / -viewPosition.z);

    vOffset = aOffset;
    vColorMix = aColorMix;
}
